// src/documents/xlsx/oleTemplateLoader.js
//
// OLE2FRAME binary blob template'ini fetch eder ve cache'ler.
// public/templates/yuklemeCetveliOleTemplate.bin → ~500KB CFB blob.

let cache = null;

/** @returns {Promise<ArrayBuffer>} */
export async function loadOleTemplate() {
  if (cache) return cache.slice(0);
  const base = process.env.PUBLIC_URL || '';
  const url = `${base}/templates/yuklemeCetveliOleTemplate.bin`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`OLE template indirilemedi: ${url} (${res.status})`);
  cache = await res.arrayBuffer();
  return cache.slice(0);
}
